import queryString from 'query-string';

import {camelCase, startCase} from 'lodash';

import {DEFAULT_BREADCRUMBS, MAX_QUICK_FILTER_VIEW_COUNT} from './constants';
import {getBrowserCookie, setBrowserCookie} from '../../../client/common/persistence/browserCookieUtils';


const getSearchPageBreadcrumbs = ({searchParam}) => {
  if (!searchParam) {
    return [];
  }

  return [
    ...DEFAULT_BREADCRUMBS,
    {
      id: `ara?q=${searchParam}`,
      url: `ara?q=${searchParam}`,
      labelText: startCase(camelCase(searchParam))
    }
  ]
}

const getCollectionPageTitle = ({searchParam}) => {
  if (!searchParam) {
    return '';
  }
  return startCase(camelCase(searchParam))
}

const clearKeyFromObject = ({object, removedKey}) => {
  return Object.keys(object)?.filter(key => key !== removedKey)?.
    reduce((obj, key) => {
      obj[key] = object?.[key];
      return obj;
    }, {}) || {}
}

const isCollectionPageCheck = ({url = ''}) => {
  let uri = url;

  if (process.env.BROWSER && window) {
    uri = url || window.location.href
  }

  const locationData = queryString.parseUrl(decodeURIComponent(uri));

  if (!locationData?.query?.q) {
    return true;
  }

  return false;
};


export {
  clearKeyFromObject,
  getSearchPageBreadcrumbs,
  getCollectionPageTitle,
  isCollectionPageCheck,
};
